import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import {
  Col,
  Row,
  Card,
  Form,
  InputGroup,
  Button,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import Datetime from "react-datetime";
import moment from "moment-timezone";
import { useCookies } from "react-cookie";
import { Context } from "../Reward";
import { clientId } from "../../../../helper/config";
import { isSuperAdminUser } from "../../../../helper/adminSession";
import { getDevicesForSelect } from "../../../../controller/api/device";

const _FilterForm = () => {
  const { state, dispatch } = useContext(Context);

  const [cookies] = useCookies(["lottmekong"]);

  const superAdmin = isSuperAdminUser();

  const [g, setG] = useState(state.filter.gameId);
  const [devices, setDevices] = useState([]);

  const _from = useRef(state.filter.from);
  const _to = useRef(state.filter.to);
  const _phone = useRef(state.filter.phone);
  const _gameId = useRef(state.filter.gameId);
  const _deviceId = useRef(state.filter.deviceId);
  const _group = useRef(state.filter.group);

  useEffect(() => {
    if (!superAdmin) return;
    let mounted = true;
    getDevicesForSelect(cookies.lottmekong).then((list) => {
      if (mounted) setDevices(list || []);
    });
    return () => {
      mounted = false;
    };
  }, [superAdmin, cookies.lottmekong]);

  const _handleChangeFrom = useCallback((payload) => {
    _from.current = payload;
  }, []);

  const _handleChangeTo = useCallback((payload) => {
    _to.current = payload;
  }, []);

  const _handleChangePhone = useCallback((payload) => {
    _phone.current = payload.target.value;
  }, []);

  const _handleChangeGame = useCallback((payload) => {
    _gameId.current = payload.target.value;
    _group.current = "";
    setG(_gameId.current);
  }, []);

  const _handleChangeDevice = useCallback((payload) => {
    _deviceId.current = payload.target.value;
  }, []);

  const _handleChangeKenoGroupTicket = useCallback((payload) => {
    _group.current = payload.target.value;
  }, []);

  const _submitForm = useCallback(() => {
    dispatch({
      type: "SUBMIT_FILTER",
      payload: {
        from: _from.current,
        to: _to.current,
        phone: _phone.current,
        gameId: _gameId.current,
        deviceId: _deviceId.current,
        group: _gameId.current !== "keno" ? "" : _group.current,
      },
    });
  }, [dispatch]);

  const _payRewardAll = useCallback(() => {
    dispatch({
      type: "PAY_REWARD_ALL",
    });
  }, [dispatch]);

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header>
          <Row className="align-items-center">
            <Col className="align-self-center" sm={12} md={8}>
              <h5>DANH SÁCH TRÚNG THƯỞNG</h5>
            </Col>
            <Col className="text-center" sm={12} md={2}>
              <Button
                style={{ marginRight: 20 }}
                variant="danger"
                type="submit"
                onClick={_payRewardAll}
              >
                Trả thưởng
              </Button>
            </Col>
            <Col className="text-center" sm={12} md={2}>
              <Button
                style={{ marginRight: 20 }}
                variant="info"
                type="submit"
                onClick={_submitForm}
              >
                Tìm kiếm
              </Button>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          {/* <Container> */}
          <Col>
            <Row className="p-1">
              <Col sm={12} md={6}>
                <Row>
                  <Col md={3} className="text-left align-self-center">
                    <Form.Label>Từ ngày</Form.Label>
                  </Col>
                  <Col md={9}>
                    <Datetime
                      timeFormat={false}
                      onChange={_handleChangeFrom}
                      renderInput={(props, openCalendar) => (
                        <InputGroup>
                          <InputGroup.Text>
                            <FontAwesomeIcon icon={faCalendarAlt} />
                          </InputGroup.Text>
                          <Form.Control
                            required
                            type="text"
                            value={
                              _from.current
                                ? moment(_from.current).format("DD/MM/YYYY")
                                : ""
                            }
                            placeholder="dd/mm/yyyy"
                            onFocus={openCalendar}
                            onChange={() => {}}
                          />
                        </InputGroup>
                      )}
                    />
                  </Col>
                </Row>
              </Col>
              <Col sm={12} md={6}>
                <Row>
                  <Col md={3} className="text-left align-self-center">
                    <Form.Label>Đến ngày</Form.Label>
                  </Col>
                  <Col md={9}>
                    <Datetime
                      timeFormat={false}
                      onChange={_handleChangeTo}
                      renderInput={(props, openCalendar) => (
                        <InputGroup>
                          <InputGroup.Text>
                            <FontAwesomeIcon icon={faCalendarAlt} />
                          </InputGroup.Text>
                          <Form.Control
                            required
                            type="text"
                            value={
                              _to.current
                                ? moment(_to.current).format("DD/MM/YYYY")
                                : ""
                            }
                            placeholder="dd/mm/yyyy"
                            onFocus={openCalendar}
                            onChange={() => {}}
                          />
                        </InputGroup>
                      )}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="p-1">
              <Col sm={12} md={6}>
                <Row>
                  <Col md={3} className="text-left align-self-center">
                    <Form.Label>Trò chơi</Form.Label>
                  </Col>
                  <Col md={9}>
                    <Form.Select onChange={_handleChangeGame}>
                      <option defaultValue value={""}>
                        Chọn trò chơi
                      </option>
                      <option value={"keno"}>Keno</option>
                      <option value={"lotto535"}>Lotto 5/35</option>
                      <option value={"mega"}>Mega 6/45</option>
                      <option value={"power"}>Power 6/55</option>
                      <option value={"max3d"}>Max3D/3D+</option>
                      <option value={"max3dpro"}>Max3D Pro</option>
                    </Form.Select>
                  </Col>
                </Row>
              </Col>
              <Col sm={12} md={6}>
                <Row>
                  <Col md={3} className="text-left align-self-center">
                    <Form.Label>Điện thoại</Form.Label>
                  </Col>
                  <Col md={9}>
                    <Form.Control
                      onChange={_handleChangePhone}
                      required
                      type="text"
                      placeholder="Nhập số điện thoại"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            {superAdmin && (
              <Row className="p-1">
                <Col sm={12} md={6}>
                  <Row>
                    <Col md={3} className="text-left align-self-center">
                      <Form.Label>Thiết bị in</Form.Label>
                    </Col>
                    <Col md={9}>
                      <Form.Select
                        defaultValue={_deviceId.current || ""}
                        onChange={_handleChangeDevice}
                      >
                        <option value={""}>Tất cả thiết bị</option>
                        {devices.map((d) => (
                          <option key={d.id} value={d.id}>
                            {d.name ? `${d.name} (${d.code})` : d.code}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
            {clientId === "luckylott" && g === "keno" && (
              <Row className="p-1">
                <Col sm={12} md={6}>
                  <Row>
                    <Col md={3} className="text-left align-self-center">
                      <Form.Label>Nhóm vé</Form.Label>
                    </Col>
                    <Col md={9}>
                      <Form.Select onChange={_handleChangeKenoGroupTicket}>
                        <>
                          <option defaultValue value={""}>
                            Tất cả
                          </option>
                          <option value={"A"}>A</option>
                          <option value={"B"}>B</option>
                        </>
                      </Form.Select>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
          </Col>
          {/* </Container> */}
        </Card.Body>
      </Card>
    </>
  );
};

export default React.memo(_FilterForm);
